import Link from 'next/link';

import usePosts from '@/hooks/contentful/usePosts';
import { getPostValues } from '@/utils/posts';

import { CategoryStack } from '../Articles/styles';
import { CategoryChip } from '../styles';
import { dateFormat } from '../utils';
import {
  CardArticle,
  DateCard,
  GeneralContainer,
  LinearGradient,
  LoadingSkeletonPost,
  TextContainer,
  TitleCard,
} from './styles';

import type { Post } from '@/@types/contentful';

interface LastArticlesProps {
  search?: string;
}

interface CardsProps {
  post: Post;
}

function LastArticles({ search }: LastArticlesProps) {
  const { posts, isLoading } = usePosts(search);
  const LastTwoPost = posts.slice(0, 2);

  return (
    <GeneralContainer>
      {LastTwoPost.map((post) => {
        const data = getPostValues(post);

        return (
          <>
            {isLoading ? (
              <LoadingSkeletonPost
                sx={{ bgcolor: '#DAEDC6' }}
                animation="pulse"
                variant="rectangular"
              />
            ) : (
              <Link key={data.postId} href={data.url}>
                <Cards post={post} />
              </Link>
            )}
          </>
        );
      })}
    </GeneralContainer>
  );
}

const Cards = ({ post }: CardsProps) => {
  const data = getPostValues(post);
  const categories = post.fields.categories;

  return (
    <LinearGradient>
      <CardArticle image={data.image}>
        <TextContainer>
          <CategoryStack mb={'0.875rem'}>
            <DateCard>{dateFormat(data.createdAt)}</DateCard>
            {categories?.map((category: any) => (
              <CategoryChip
                key={category?.sys.id}
                variant="filled"
                color="primary"
                label={category?.fields.categoryName}
                size="small"
              />
            ))}
          </CategoryStack>
          <TitleCard>{post?.fields.title}</TitleCard>
        </TextContainer>
      </CardArticle>
    </LinearGradient>
  );
};

export default LastArticles;
